import { Card, Form } from "react-bootstrap";
import { IntegrationStatus, SubscriptionStatus } from "./Data/ApiTransport";
import { Vehicle } from "./Data/ApiTypes";
import { getStateEnumFromCode, showStateName } from "./Data/UsState";
import {
  ServerRequestsParkerIntegrationPartyDto,
} from "./shared/api/axios-client";
import { CarFrontFill, Trash } from "react-bootstrap-icons";

interface ReservationVehicleCardProps {
  vehicle: Vehicle;
  onRemove: (vehicle: Vehicle) => void;
  subscriptionStatus: SubscriptionStatus;
  integrations: ServerRequestsParkerIntegrationPartyDto[];
  subscriptionId: number;
  facilityId: number;
  setPendingToggle: (data: {
    integrationPartyId: number;
    subscriptionId: number;
    parkerId: number;
    facilityId: number;
    newStatus: IntegrationStatus;
    vehicleId: number;
  }) => void;
  setShowToggleConfirm: (show: boolean) => void;
}

export function ReservationVehicleCard({
  vehicle,
  onRemove,
  subscriptionStatus,
  integrations,
  subscriptionId,
  facilityId,
  setPendingToggle,
  setShowToggleConfirm,
}: ReservationVehicleCardProps) {
  const vehicleIntegrations = integrations.filter(
    (x) =>
      (x.vehicleId !== undefined && x.vehicleId === vehicle.vehicleId) 
  );
  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex align-items-center gap-2">
            <div
              className="rounded-2 border border-secondary d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                backgroundColor:
                  vehicle.color === "black"
                    ? "#f8f9fa"
                    : vehicle.color === "White"
                    ? "#343a40"
                    : "",
              }}
            >
              <CarFrontFill
                style={{
                  width: "20px",
                  height: "20px",
                  color: vehicle.color,
                }}
              />
            </div>

            <div>
              <div className="fw-bold">
                {vehicle.make} {vehicle.model}
              </div>
              <div className="text-muted small">
                {showStateName(getStateEnumFromCode(vehicle.stateCode)!)}{" "}
                {vehicle.licensePlateNumber}
              </div>
            </div>
          </div>

          {(subscriptionStatus === SubscriptionStatus.Active ||
            subscriptionStatus === SubscriptionStatus.Applied) && (

          <button
              className="btn btn-sm"
              title="Delete Vehicle"
              onClick={() => onRemove(vehicle)}
          >
            <Trash />
          </button>
          )}
        </div>

        {vehicleIntegrations.length > 0 && (
          <div className="mt-3">
            {vehicleIntegrations.map((integration) => (
              <div
                key={`${integration.integrationPartyId}-${
                  integration.vehicleId ?? vehicle.vehicleId
                }`}
                className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <div className="fw-bold small">
                  {integration.integrationName}
                </div>

                {setPendingToggle && setShowToggleConfirm && (
                  <Form.Check
                    type="switch"
                    id={`integration-toggle-${integration.integrationPartyId}-${
                      integration.vehicleId ?? vehicle.vehicleId
                    }`}
                    checked={integration.isActive || false}
                    onChange={() =>
                      setPendingToggle({
                        integrationPartyId: integration.integrationPartyId!,
                        subscriptionId: subscriptionId,
                        parkerId: integration.parkerId!,
                        vehicleId: integration.vehicleId!,
                        facilityId: facilityId,
                        newStatus: integration.isActive
                          ? IntegrationStatus.Deactivated
                          : IntegrationStatus.Activated,
                      })
                    }
                    onClick={() => setShowToggleConfirm(true)}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
